import { render, staticRenderFns } from "./phone-ringing.vue?vue&type=template&id=3a4ace22"
import script from "./phone-ringing.vue?vue&type=script&lang=js"
export * from "./phone-ringing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports